__turbopack_context__.v({
  "className": "cormorant_garamond_480231d7-module__gOi1aq__className",
});
